export default "__VITE_ASSET__BCoajjye__"